import { OrderingInitialState, SetCustomerPhoneNumberForSmsAction } from '@reducers/ordering/types';

export const setCustomerPhoneNumberForSms = (
  state: OrderingInitialState,
  action: SetCustomerPhoneNumberForSmsAction
): OrderingInitialState => ({
  ...state,
  customerState: {
    ...state.customerState,
    selectPhoneForSms: action.payload,
  },
});
